import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VaccinationFormComponent } from './vaccination-form.component/vaccination-form.component';
import { FormsModule } from '@angular/forms';
import { VaccinaionDropDownSelectComponent } from './vaccinaion-drop-down-select.component/vaccinaion-drop-down-select.component';
import { AppCommonModule } from 'src/app/common/common.module';
import { VaccinSelectDrawerComponent } from './vaccin-select-drawer.component/vaccin-select-drawer.component';

@NgModule({
  declarations: [
    VaccinationFormComponent,
    VaccinaionDropDownSelectComponent,
    VaccinSelectDrawerComponent
  ],
  imports: [
    CommonModule,
    AppCommonModule,
    FormsModule
  ],
  exports: [
    VaccinationFormComponent,
    VaccinaionDropDownSelectComponent,
    VaccinSelectDrawerComponent
  ]
})
export class VaccinationFormModule { }
